import { FACILITY_METRICS_QUERY } from '../data-access/facility-metrics-query'
import { BaseQuery } from './BaseQuery'
import {
  facilityMetrics,
  facilityMetricsVariables
} from '../data-access/__generated__/types'

export class FacilityMetricsQuery extends BaseQuery<
  facilityMetrics,
  facilityMetricsVariables
> {
  query = FACILITY_METRICS_QUERY
}
